import { EHR_PERMISSIONS, useStorage } from '@/libs/storage'
import { TEMPLATE_TYPES } from '@/models/clinicalRecord/template'
import { HEALTH_PLAN_TASK_TYPE } from '@/models/healthPlan/tasks'

const { getItem } = useStorage(EHR_PERMISSIONS)

export default getItem() || {
  pillars: {
    pillarsPreset: null,
    visibleTabs: null
  },
  menu: {
    visibleMenus: null
  },
  home: {
    homepage: null
  },
  user: {
    general: {
      update: false
    },
    onCall: {
      view: false
    },
    certificate: {
      view: false
    }
  },
  channels: {
    general: {
      view: false,
      create: false
    },
    staff: {
      canShowArchiveModal: false,
      canShowArchiveButtonInChannel: false,
      viewAllChannelMessages: true
    }
  },
  clinicalProfile: {
    cpt: {
      update: false
    },
    healthLogics: {
      view: false
    }
  },
  clinicalRecord: {
    general: {
      defaultTemplateType: TEMPLATE_TYPES.SOAP
    },
    secondOpinion: {
      view: false
    }
  },
  demands: {
    general: {
      validate: false
    }
  },
  healthCommunity: {
    general: {
      view: false
    }
  },
  healthPlan: {
    general: {
      showSummary: false,
      defaultFilters: []
    },
    filters: {
      view: false
    },
    tasks: {
      [HEALTH_PLAN_TASK_TYPE.PRESCRIPTION]: {
        view: false,
        create: false,
        publish: false,
        isMemed: false
      },
      [HEALTH_PLAN_TASK_TYPE.TEST_REQUEST]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.EATING]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.EMERGENCY]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.MOOD]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.OTHERS]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.PHYSICAL_ACTIVITY]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.REFERRAL]: {
        view: false,
        create: false,
        publish: false
      },
      [HEALTH_PLAN_TASK_TYPE.SLEEP]: {
        view: false,
        create: false,
        publish: false
      }
    }
  },
  testResults: {
    analysis: {
      view: false
    }
  },
  timeline: {
    counterReferral: {
      create: false
    },
    filters: {
      view: false
    }
  },
  dalyaRecommendation: false
}
